import { GitConfigDivergence } from '@/react/portainer/gitops/utils';

import { Alert } from '@@/Alert';

export function DivergenceAlert({
  divergence,
}: {
  divergence: GitConfigDivergence;
}) {
  return (
    <Alert color="info" className="mt-4">
      <div className="flex flex-col gap-1 text-sm">
        <strong>Settings changed since last deploy</strong>
        <div>
          Next: {divergence.url && <code>{divergence.url}</code>}{' '}
          {divergence.reference && <code>{divergence.reference}</code>} Config:{' '}
          <code>{divergence.configFilePath ?? ''}</code>
        </div>
      </div>
    </Alert>
  );
}
